export default __webpack_public_path__ + "static/media/staff1.255fc6b3.jpg";